:host {
  display: block;
  padding: 0;
  margin: 0;
}

:host.divider-horizontal {
  width: 100%;
}

:host.divider-vertical {
  height: 100%;
}

:host.divider-small.divider-horizontal {
  height: var(--border-size-small);
}

:host.divider-medium.divider-horizontal {
  height: var(--border-size-medium);
}

:host.divider-large.divider-horizontal {
  height: var(--border-size-large);
}

:host.divider-small.divider-vertical {
  width: var(--border-size-small);
}

:host.divider-medium.divider-vertical {
  width: var(--border-size-medium);
}

:host.divider-large.divider-vertical {
  width: var(--border-size-large);
}
